import { useUserAuth } from '~/components/Auth';

import { WGLL_BASE_URL, WGLL_DEFAULT_PATHS, WgllConfigKey } from './constants';

export const useWgllPath = (key: WgllConfigKey): string => {
  const { tempFeatureConfig = {} } = useUserAuth() || {};
  return tempFeatureConfig?.wgllConfig?.[key] || WGLL_DEFAULT_PATHS[key];
};

export const buildSrc = (path: string): string => `${WGLL_BASE_URL}/${path.replace(/^\//, '')}`;
